/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline. Keeping your custom
* Javascript in this file will make it easier to update Pipeline.
*/

console.log('[ED BUNDLE] loaded v2026-02-10-native-v14-qty-respects-selector-hide-main-size-hook');

/* =========================================================
   Pipeline debug listener (optional)
   ========================================================= */
window.__edSelectedVariant = window.__edSelectedVariant || null;

document.addEventListener('theme:variant:change', function (event) {
  var variant = event.detail && event.detail.variant;
  if (variant && variant.id) window.__edSelectedVariant = variant;
});

/* =========================================================
   Move Color above Size on product form
   ========================================================= */
function moveColorAboveSize() {
  document.querySelectorAll('.form__selectors').forEach(function (wrap) {
    const colorWrapper =
      wrap.querySelector('.selector-wrapper--color') ||
      wrap.querySelector('[data-select-label="Color"]');

    const sizeWrapper =
      wrap.querySelector('[data-select-label="Size"]');

    if (colorWrapper && sizeWrapper && colorWrapper !== wrap.firstElementChild) {
      wrap.insertBefore(colorWrapper, sizeWrapper);
    }
  });
}

document.addEventListener('DOMContentLoaded', moveColorAboveSize);
document.addEventListener('shopify:section:load', moveColorAboveSize);
document.addEventListener('theme:variant:change', function () {
  setTimeout(moveColorAboveSize, 0);
});

/* =========================================================
   Collection hover swatch fix (KEEP)
   ========================================================= */
function enApplyGridSwatchImages(root) {
  (root || document)
    .querySelectorAll('form[data-grid-swatches] label[data-swatch-image]')
    .forEach(function (label) {
      var url = label.getAttribute('data-swatch-image');
      if (!url) return;

      label.style.setProperty('--swatch-image', 'url("' + url + '")');
      label.setAttribute('data-fetched-image', 'url("' + url + '")');
    });
}

function enStartGridSwatchImages() {
  enApplyGridSwatchImages(document);

  if (window.__enGridSwatchImageObserver) return;

  window.__enGridSwatchImageObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;

        enApplyGridSwatchImages(node);

        if (
          node.matches &&
          node.matches('form[data-grid-swatches] label[data-swatch-image]')
        ) {
          var url = node.getAttribute('data-swatch-image');

          if (url) {
            node.style.setProperty('--swatch-image', 'url("' + url + '")');
            node.setAttribute('data-fetched-image', 'url("' + url + '")');
          }
        }
      });
    });
  });

  window.__enGridSwatchImageObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', enStartGridSwatchImages, {
    once: true
  });
} else {
  enStartGridSwatchImages();
}

window.addEventListener('pageshow', function () {
  enApplyGridSwatchImages(document);
});

document.addEventListener('shopify:section:load', function (event) {
  enApplyGridSwatchImages(event.target);
});

(function () {
  /* ---------- helpers ---------- */
  function waitFor(selector, timeout = 8000) {
    return new Promise((resolve, reject) => {
      const start = Date.now();
      const tick = () => {
        const el = document.querySelector(selector);
        if (el) return resolve(el);
        if (Date.now() - start > timeout) return reject(new Error('Timeout waiting for: ' + selector));
        requestAnimationFrame(tick);
      };
      tick();
    });
  }

  function readJSONScript(selector) {
    const el = document.querySelector(selector);
    if (!el) return null;
    try { return JSON.parse(el.textContent.trim()); } catch { return null; }
  }

  function safeInt(x, fallback = 0) {
    const n = parseInt(String(x), 10);
    return Number.isFinite(n) ? n : fallback;
  }

  function tierQty(t) {
    return safeInt(t?.qty ?? t?.quantity ?? 0, 0);
  }

  function uniq(arr) {
    return Array.from(new Set(arr)).filter(Boolean);
  }

  function setATCPrice(cents) {
    const priceEl = document.querySelector('[data-button-price]');
    if (!priceEl) return;
    priceEl.innerHTML = `<span class="glc-money">$${(cents / 100).toFixed(0)}</span>`;
  }

  function ensureInput(form, name, type = 'hidden') {
    let input = form.querySelector(`input[name="${CSS.escape(name)}"]`);
    if (!input) {
      input = document.createElement('input');
      input.type = type;
      input.name = name;
      form.appendChild(input);
    }
    return input;
  }

  function cleanupTempInputs(form) {
    form.querySelectorAll('[data-ed-temp="1"]').forEach(el => el.remove());
  }

  function injectTempInput(form, name, value) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = String(value);
    input.setAttribute('data-ed-temp', '1');
    form.appendChild(input);
    return input;
  }

  // ✅ Read quantity from the actual Pipeline quantity input
  function getCurrentQtyFromForm(form) {
    const el =
      form.querySelector('input.quantity__input[data-quantity-input]') ||
      document.querySelector('input.quantity__input[data-quantity-input]') ||
      form.querySelector('input[data-quantity-input]') ||
      document.querySelector('input[data-quantity-input]') ||
      form.querySelector('input[name="quantity"]');

    const n = el ? parseInt(el.value, 10) : 1;
    return Number.isFinite(n) && n > 0 ? n : 1;
  }

  async function fetchProductJSON(handle) {
    const res = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Failed to load product JSON for: ' + handle);
    return await res.json();
  }

  // ASSUMPTION: option1 = Size, option2 = Color
  function findVariant(product, sizeVal, colorVal) {
    return product.variants.find(v => v.option1 === sizeVal && v.option2 === colorVal) || null;
  }

  function getBestImageFromVariantOrProduct(variant, productJSON) {
    const vImg = variant && variant.featured_image;
    const vSrc = vImg && (vImg.src || vImg);
    if (vSrc) return vSrc;
    if (productJSON && productJSON.featured_image) return productJSON.featured_image;
    if (productJSON && Array.isArray(productJSON.images) && productJSON.images.length) return productJSON.images[0];
    return '';
  }

  function isCartAddUrl(url) {
    try { return String(url || '').includes('/cart/add'); } catch { return false; }
  }

  /* =========================================================
     KEEP “no duplicate item” fix: strip id/quantity when items[] exists
     ========================================================= */
  function sanitizeBody(body) {
    try {
      if (!body) return { body, sanitized: false };

      // FormData
      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        let hasItems = false;
        for (const [k] of body.entries()) {
          const key = String(k);
          if (key.startsWith('items[') && key.endsWith('][id]')) { hasItems = true; break; }
        }
        if (!hasItems) return { body, sanitized: false };

        const fd = new FormData();
        for (const [k, v] of body.entries()) fd.append(k, v);
        fd.delete('id'); fd.delete('quantity'); fd.delete('id[]'); fd.delete('quantity[]');
        return { body: fd, sanitized: true };
      }

      // URLSearchParams
      if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
        let hasItems = false;
        for (const k of body.keys()) {
          const key = String(k);
          if (key.startsWith('items[') && key.endsWith('][id]')) { hasItems = true; break; }
        }
        if (!hasItems) return { body, sanitized: false };

        const usp = new URLSearchParams(body.toString());
        usp.delete('id'); usp.delete('quantity'); usp.delete('id[]'); usp.delete('quantity[]');
        return { body: usp, sanitized: true };
      }

      // string
      if (typeof body === 'string') {
        const hasItems = (body.includes('items%5B') && body.includes('%5D%5Bid%5D')) || (body.includes('items[') && body.includes('][id]'));
        if (!hasItems) return { body, sanitized: false };

        const usp = new URLSearchParams(body);
        usp.delete('id'); usp.delete('quantity'); usp.delete('id[]'); usp.delete('quantity[]');
        return { body: usp.toString(), sanitized: true };
      }
    } catch (_) {}

    return { body, sanitized: false };
  }

  (function installFetchSanitizerOnce() {
    if (window.__edFetchSanitizerInstalled) return;
    window.__edFetchSanitizerInstalled = true;
    const origFetch = window.fetch;

    window.fetch = function (input, init) {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      if (!isCartAddUrl(url)) return origFetch.apply(this, arguments);

      try {
        const cfg = init || {};
        const out = sanitizeBody(cfg.body);
        if (out.sanitized) return origFetch.call(this, input, Object.assign({}, cfg, { body: out.body }));
      } catch (_) {}

      return origFetch.apply(this, arguments);
    };
  })();

  (function installXHRSanitizerOnce() {
    if (window.__edXHRSanitizerInstalled) return;
    window.__edXHRSanitizerInstalled = true;

    const origOpen = XMLHttpRequest.prototype.open;
    const origSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__ed_isCartAdd = isCartAddUrl(url);
      return origOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function (body) {
      try {
        if (this.__ed_isCartAdd) {
          const out = sanitizeBody(body);
          if (out.sanitized) return origSend.call(this, out.body);
        }
      } catch (_) {}
      return origSend.apply(this, arguments);
    };
  })();

  /* =========================================================
     MAIN selector sync (already working)
     ========================================================= */
  function updatePopoutButtonText(form, type /* 'size'|'color' */, text) {
    if (!text) return;
    const controlsKey = type === 'size' ? 'select-size' : 'select-color';
    const btn =
      form.querySelector(`button.select-popout__toggle[aria-controls*="${controlsKey}"]`) ||
      document.querySelector(`button.select-popout__toggle[aria-controls*="${controlsKey}"]`);
    if (!btn) return;

    btn.textContent = text;
    btn.setAttribute('data-user-selected', 'true');
    btn.setAttribute('data-placeholder-set', 'true');
    btn.setAttribute('aria-expanded', 'false');
  }

  function setColorSwatchRadio(form, colorVal) {
    if (!colorVal) return;
    const selector = `input[type="radio"][name="options[Color]"][value="${CSS.escape(colorVal)}"]`;
    const input = form.querySelector(selector) || document.querySelector(selector);
    if (!input) return;

    if (!input.checked) {
      input.checked = true;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function setMainSelectorsFromVariant(form, variant) {
    if (!variant) return;

    ensureInput(form, 'id', 'hidden').value = String(variant.id);

    // don't force to 1 here
    const qty = ensureInput(form, 'quantity', 'hidden');
    if (!qty.value) qty.value = '1';

    updatePopoutButtonText(form, 'size', variant.option1);
    updatePopoutButtonText(form, 'color', variant.option2);
    setColorSwatchRadio(form, variant.option2);
  }

  /* =========================================================
     Bundle line custom popout (keeps SAME layout structure)
     ========================================================= */
  function closeAllLinePopouts(root) {
    (root || document).querySelectorAll('.ed-line-popout.is-open').forEach(p => {
      p.classList.remove('is-open');
      const menu = p.querySelector('.ed-line-popout__menu');
      if (menu) menu.hidden = true;
      const btn = p.querySelector('.ed-line-popout__toggle');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  function createLinePopout({ values, value, onChange }) {
    const wrap = document.createElement('div');
    wrap.className = 'ed-line-popout';

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ed-line-popout__toggle';
    btn.setAttribute('aria-expanded', 'false');
    btn.textContent = value || 'Select';

    const menu = document.createElement('div');
    menu.className = 'ed-line-popout__menu';
    menu.hidden = true;

    function setVal(v) {
      btn.textContent = v;
      wrap.dataset.value = v;
      closeAllLinePopouts(wrap.closest('[data-ed-bundle]') || document);
      onChange && onChange(v);
    }

    values.forEach(v => {
      const opt = document.createElement('button');
      opt.type = 'button';
      opt.className = 'ed-line-popout__option';
      opt.textContent = v;
      opt.addEventListener('click', () => setVal(v));
      menu.appendChild(opt);
    });

    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const root = wrap.closest('[data-ed-bundle]') || document;
      const willOpen = !wrap.classList.contains('is-open');
      closeAllLinePopouts(root);
      wrap.classList.toggle('is-open', willOpen);
      menu.hidden = !willOpen;
      btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    });

    wrap.appendChild(btn);
    wrap.appendChild(menu);

    wrap.__get = () => wrap.dataset.value || btn.textContent;
    wrap.__set = (v) => setVal(v);

    wrap.dataset.value = value || '';
    return wrap;
  }

  if (!window.__edLinePopoutGlobalHandlers) {
    window.__edLinePopoutGlobalHandlers = true;
    document.addEventListener('click', () => closeAllLinePopouts(document), true);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAllLinePopouts(document); }, true);
  }

  async function initEDBundle() {
    const mount = document.querySelector('[data-ed-bundle]');
    if (!mount) return;

    // ✅ Hook class for CSS (hide size selector on bundle products)
    document.documentElement.classList.add('ed-bundle-active');

    await waitFor('script[data-ed-bundle-config]').catch(() => null);
    await waitFor('form[action*="/cart/add"]').catch(() => null);

    const config = readJSONScript('script[data-ed-bundle-config]');
    if (!config || !Array.isArray(config.tiers) || !config.tiers.length) return;

    const productSection = document.querySelector('[data-section-type="product"]');
    const form =
      productSection?.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    /* =========================================================
       1-pack warning: show + BLOCK until size is actually selected
       (fixes flicker by using click/submit only)
       ========================================================= */
    function getATCButton() {
      return form.querySelector('button[type="submit"][name="add"], button[type="submit"], [data-add-to-cart]');
    }

    function getSizeToggleButton() {
      return (
        form.querySelector('button.select-popout__toggle[aria-controls*="select-size"]') ||
        document.querySelector('button.select-popout__toggle[aria-controls*="select-size"]')
      );
    }

    function ensureSizeErrorEl() {
      let el = form.querySelector('.ed-size-error');
      if (el) return el;

      el = document.createElement('div');
      el.className = 'ed-size-error';
      el.setAttribute('role', 'alert');
      el.hidden = true;
      el.textContent = 'Please select a size.';

      const atcBtn = getATCButton();
      if (atcBtn && atcBtn.parentNode) atcBtn.parentNode.insertBefore(el, atcBtn);
      else form.prepend(el);

      return el;
    }

    function showSizeError() {
      const el = ensureSizeErrorEl();
      el.hidden = false;

      const sizeBtn = getSizeToggleButton();
      if (sizeBtn) sizeBtn.classList.add('ed-size-error--focus');

      try { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (_) {}
      try { sizeBtn && sizeBtn.focus({ preventScroll: true }); } catch (_) {}
    }

    function hideSizeError() {
      const el = form.querySelector('.ed-size-error');
      if (el) el.hidden = true;

      const sizeBtn = getSizeToggleButton();
      if (sizeBtn) sizeBtn.classList.remove('ed-size-error--focus');
    }

    function sizeIsActuallySelected() {
      // Preferred: your sync sets data-user-selected=true when user has a real size in the button
      const sizeBtn = getSizeToggleButton();
      if (sizeBtn && sizeBtn.getAttribute('data-user-selected') === 'true') return true;

      // Fallbacks: select/radio size markup
      const sel = form.querySelector('select[name="options[Size]"]');
      if (sel && String(sel.value || '').trim() !== '') return true;

      const radio = form.querySelector('input[type="radio"][name="options[Size]"]:checked');
      if (radio && String(radio.value || '').trim() !== '') return true;

      return false;
    }

    // Only hide the warning when a size is truly selected
    document.addEventListener('theme:variant:change', function () {
      if (sizeIsActuallySelected()) hideSizeError();
    }, true);

    function getActivePackQty() {
      const btn = mount.querySelector('.ed-bundle__tier.is-active');
      return btn ? safeInt(btn.dataset.qty, 1) : 1;
    }

   function getCurrentVariantId() {
  const chosen = window.__edSelectedVariant;
  if (chosen && chosen.id) return String(chosen.id);

  const idInput =
    form.querySelector('input[name="id"]') ||
    document.querySelector('form[action*="/cart/add"] input[name="id"]') ||
    document.querySelector('input[name="id"]');

  const idVal = idInput ? String(idInput.value || '').trim() : '';

  return idVal && /^\d+$/.test(idVal) ? idVal : '';
}

function onePackCanATC() {
  return !!getCurrentVariantId();
}

    // Hard stop on submit (last defense)
    form.addEventListener('submit', function (e) {
      const packQty = getActivePackQty();
      if (packQty !== 1) return;

      if (!onePackCanATC()) {
        e.preventDefault();
        e.stopPropagation();
        showSizeError();
      }
    }, true);

    const HANDLE = productSection?.getAttribute('data-product-handle') || 'product';
    const STORE_KEY = `ed_bundle_qty:${HANDLE}`;

    const productJSON = await fetchProductJSON(HANDLE);
    const SIZE_VALUES = uniq(productJSON.variants.map(v => v.option1));
    const COLOR_VALUES = uniq(productJSON.variants.map(v => v.option2));

    function setStoredQty(q) { sessionStorage.setItem(STORE_KEY, String(q)); }

    let activeTier = config.tiers[0];

    function getActiveTierFromDOM() {
      const btn = mount.querySelector('.ed-bundle__tier.is-active');
      if (!btn) return activeTier;
      const qty = safeInt(btn.dataset.qty, tierQty(activeTier) || 1);
      return config.tiers.find(t => tierQty(t) === qty) || activeTier;
    }

    // Render
    mount.innerHTML = `
      <div class="ed-bundle__tiers">
        ${config.tiers.map((t, i) => {
          const q = tierQty(t) || 1;
          const isFirst = i === 0;

          const editorHTML = (q === 1) ? '' : `
            <div class="ed-bundle__editor ${isFirst ? 'is-open' : ''}" data-editor-for="${q}">
              <div class="ed-bundle__editor-grid">
                ${Array.from({ length: q }).map((_, idx) => `
                  <div class="ed-bundle__line" data-line="${idx}">
                    <div class="ed-bundle__line-thumb"></div>

                    <div class="ed-bundle__field" data-ed-field="size">
                      <label>Size</label>
                      <div class="ed-line-popout-mount" data-mount="size"></div>
                    </div>

                    <div class="ed-bundle__field" data-ed-field="color">
                      <label>Color</label>
                      <div class="ed-line-popout-mount" data-mount="color"></div>
                    </div>

                    <input type="hidden" data-variant-id value="">
                  </div>
                `).join('')}
              </div>
            </div>
          `;

          const compare = safeInt(t.compareAtTotalPrice, 0);

          const tierBtn = `
            <button type="button"
              class="ed-bundle__tier ${isFirst ? 'is-active' : ''}"
              data-qty="${q}"
              data-total="${t.totalPrice}">

              <div class="ed-bundle__tier-left">
                <div class="ed-bundle__tier-label">${t.label || (q + ' pack')}</div>

                ${t.badge ? `<div class="ed-bundle__tier-badge">${t.badge}</div>` : ''}

                ${t.description ? `<div class="ed-bundle__tier-desc">${t.description}</div>` : ''}
              </div>

              <div class="ed-bundle__tier-right">
                <div class="ed-bundle__tier-price">$${(t.totalPrice / 100).toFixed(0)}</div>
                ${compare > 0 ? `<div class="ed-bundle__tier-compare">$${(compare / 100).toFixed(0)}</div>` : ''}
              </div>

            </button>
          `;

          const titleBetween = (i === 0)
            ? `<div class="ed-bundle__title ed-bundle__title--between">${config.title || 'BUNDLE & SAVE'}</div>`
            : '';

          return tierBtn + titleBetween + editorHTML;
        }).join('')}
      </div>
    `;

    function closeAllEditors() {
      mount.querySelectorAll('.ed-bundle__editor').forEach(ed => ed.classList.remove('is-open'));
    }

    function openEditorForQty(qty) {
      closeAllEditors();
      const editor = mount.querySelector(`.ed-bundle__editor[data-editor-for="${qty}"]`);
      if (editor) editor.classList.add('is-open');
    }

    function applyBundlePrice() {
      activeTier = getActiveTierFromDOM();
      setATCPrice(safeInt(activeTier.totalPrice, 0));
      setTimeout(() => {
        activeTier = getActiveTierFromDOM();
        setATCPrice(safeInt(activeTier.totalPrice, 0));
      }, 0);
    }

    function enforceBundleATCPrice() {
      const packQty = getActivePackQty();
      if (packQty <= 1) return;

      activeTier = getActiveTierFromDOM();
      const cents = safeInt(activeTier.totalPrice, 0);

      setATCPrice(cents);
      requestAnimationFrame(() => setATCPrice(cents));
      setTimeout(() => setATCPrice(cents), 60);
    }

    applyBundlePrice();

    function hydrateEditorForQty(qty) {
      const editor = mount.querySelector(`.ed-bundle__editor.is-open[data-editor-for="${qty}"]`);
      if (!editor) return;

      editor.querySelectorAll('.ed-bundle__line').forEach((line, idx) => {
        const vidInput = line.querySelector('[data-variant-id]');
        const thumb = line.querySelector('.ed-bundle__line-thumb');

        const chosen = window.__edSelectedVariant;
        const defaultSize = (chosen && SIZE_VALUES.includes(chosen.option1)) ? chosen.option1 : (SIZE_VALUES[0] || '');
        const defaultColor = (chosen && COLOR_VALUES.includes(chosen.option2)) ? chosen.option2 : (COLOR_VALUES[0] || '');

        const mountSize = line.querySelector('.ed-line-popout-mount[data-mount="size"]');
        const mountColor = line.querySelector('.ed-line-popout-mount[data-mount="color"]');
        if (!mountSize || !mountColor) return;

        mountSize.innerHTML = '';
        mountColor.innerHTML = '';

        let popSize, popColor;

        function sync() {
          const sizeVal = popSize.__get();
          const colorVal = popColor.__get();

          const v = findVariant(productJSON, sizeVal, colorVal);
          if (v && v.id) {
            vidInput.value = String(v.id);
            line.classList.remove('is-invalid');

            const src = getBestImageFromVariantOrProduct(v, productJSON);
            if (thumb && src) {
              thumb.style.backgroundImage = `url("${src}")`;
              thumb.style.backgroundSize = 'cover';
              thumb.style.backgroundPosition = 'center';
            }

            if (idx === 0) {
              setMainSelectorsFromVariant(form, v);
              enforceBundleATCPrice();
            }
          } else {
            vidInput.value = '';
            line.classList.add('is-invalid');
          }
        }

        popSize = createLinePopout({ values: SIZE_VALUES, value: defaultSize, onChange: sync });
        popColor = createLinePopout({ values: COLOR_VALUES, value: defaultColor, onChange: sync });

        mountSize.appendChild(popSize);
        mountColor.appendChild(popColor);

        sync();
      });
    }

    // Force default to 1-pack on load
    const onePackBtn = mount.querySelector('.ed-bundle__tier[data-qty="1"]');
    if (onePackBtn) {
      mount.querySelectorAll('.ed-bundle__tier').forEach(x => x.classList.remove('is-active'));
      onePackBtn.classList.add('is-active');
      closeAllEditors();
      setStoredQty(1);
      mount.dataset.selectedQty = "1";
      applyBundlePrice();
      const chosen = window.__edSelectedVariant;
      if (chosen && chosen.id) setMainSelectorsFromVariant(form, chosen);
    }

    // Tier click
    mount.addEventListener('click', (e) => {
      const btn = e.target.closest('.ed-bundle__tier');
      if (!btn) return;

      mount.querySelectorAll('.ed-bundle__tier').forEach(x => x.classList.remove('is-active'));
      btn.classList.add('is-active');

      const qty = safeInt(btn.dataset.qty, 1);
      setStoredQty(qty);
      mount.dataset.selectedQty = String(qty);

      if (qty === 1) {
        closeAllEditors();
      } else {
        openEditorForQty(qty);
        hydrateEditorForQty(qty);
        // multipack has its own selectors; never show 1-pack error there
        hideSizeError();
      }

      applyBundlePrice();
      enforceBundleATCPrice();
    });

    document.addEventListener('theme:variant:change', enforceBundleATCPrice, true);
    form.addEventListener('change', enforceBundleATCPrice, true);
    form.addEventListener('input', enforceBundleATCPrice, true);

    /* ---------- prep before ATC ---------- */
    let prepared = false;

    function prepFormForBundle() {
      const packQty = getActivePackQty();
      const q = getCurrentQtyFromForm(form);
// 1-pack: native add, use current Shopify variant
if (packQty === 1) {
  cleanupTempInputs(form);

  const variantId = getCurrentVariantId();

  if (!variantId) {
    showSizeError();
    return false;
  }

  ensureInput(form, 'id', 'hidden').value = String(variantId);
  ensureInput(form, 'quantity', 'hidden').value = String(q);

  prepared = true;
  return true;
}

      // multipack: add q of EACH line item
      const editor = mount.querySelector(`.ed-bundle__editor.is-open[data-editor-for="${packQty}"]`);
      if (!editor) return false;

      const lines = Array.from(editor.querySelectorAll('.ed-bundle__line'));
      const variantIds = lines.map(l => (l.querySelector('[data-variant-id]') || {}).value).filter(Boolean);
      if (variantIds.length !== packQty) return false;

      const topId = variantIds[0];
      const topVariant = productJSON.variants.find(v => String(v.id) === String(topId));
      if (topVariant) setMainSelectorsFromVariant(form, topVariant);

      cleanupTempInputs(form);

      const bundleKey = `ed_${Date.now()}`;
      variantIds.forEach((id, i) => {
        injectTempInput(form, `items[${i}][id]`, Number(id));
        injectTempInput(form, `items[${i}][quantity]`, q);
        injectTempInput(form, `items[${i}][properties][_ed_bundle]`, bundleKey);
        injectTempInput(form, `items[${i}][properties][_ed_bundle_qty]`, packQty);
        injectTempInput(form, `items[${i}][properties][_ed_bundle_line]`, i + 1);
      });

      ensureInput(form, 'id', 'hidden').value = String(topId);
      ensureInput(form, 'quantity', 'hidden').value = String(q);

      prepared = true;
      return true;
    }

    function cleanupAfterAdd() {
      if (!prepared) return;
      cleanupTempInputs(form);
      prepared = false;
    }

    document.addEventListener('theme:cart:added', cleanupAfterAdd, true);
    document.addEventListener('theme:product:added', cleanupAfterAdd, true);

    // CLICK ONLY (no pointerdown/mousedown/touchstart) -> prevents flicker
    function onATCIntentCapture(e) {
      const atc = e.target.closest('button[type="submit"][name="add"], button[type="submit"], [data-add-to-cart]');
      if (!atc) return;
      if (!atc.closest('form') || atc.closest('form') !== form) return;

      const packQty = getActivePackQty();

      // 1-pack: block unless size is actually selected
      if (packQty === 1 && !onePackCanATC()) {
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        showSizeError();
        return;
      }

      prepFormForBundle();
    }

    if (!window.__edBundleNativePrepInstalled) {
      window.__edBundleNativePrepInstalled = true;
      document.addEventListener('click', onATCIntentCapture, true);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEDBundle);
  } else {
    initEDBundle();
  }
})();


document.addEventListener('DOMContentLoaded', function () {
  function forceSalePriceRed() {
    document.querySelectorAll('.product__price--off .glc-money').forEach(function(el) {
      el.style.setProperty('color', '#ff3b3b', 'important');
    });
  }

  forceSalePriceRed();

  const observer = new MutationObserver(forceSalePriceRed);
  observer.observe(document.body, { childList: true, subtree: true });
});

/* =========================================================
   Mobile collection product image indicator blocks
   Safe version: does NOT inject inside image divs
   ========================================================= */
(function () {
  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function getCard(image) {
    return (
      image.closest('.product-grid-item__container') ||
      image.closest('.product-grid-item') ||
      image.closest('.grid__item')
    );
  }

  function getActiveImage(images) {
    return (
      images.find(function (img) {
        return img.classList.contains('is-active');
      }) || images[0]
    );
  }

  function positionDots(card, images) {
    const activeImage = getActiveImage(images);
    const dots = card.querySelector('.en-mobile-image-dots');

    if (!activeImage || !dots) return;

    const cardRect = card.getBoundingClientRect();
    const imageRect = activeImage.getBoundingClientRect();

    /*
      Place dots near bottom of visible image.
      Increase 22 to move lower.
      Decrease 22 to move higher.
    */
    const top = imageRect.bottom - cardRect.top;

    card.style.setProperty('--en-dots-top', top + 'px');
  }

  function buildMobileImageDots(root) {
    if (!isMobile()) return;

    const scope = root || document;

    scope.querySelectorAll('[data-grid-image]').forEach(function (image) {
      const card = getCard(image);
      if (!card || card.dataset.enMobileDotsReady === 'true') return;

      const images = Array.from(card.querySelectorAll('[data-grid-image]'));
      if (images.length <= 1) return;

      card.dataset.enMobileDotsReady = 'true';

      const dotsWrap = document.createElement('div');
      dotsWrap.className = 'en-mobile-image-dots';

      images.forEach(function (_, index) {
        const dot = document.createElement('span');
        dot.className = 'en-mobile-image-dot' + (index === 0 ? ' is-active' : '');
        dot.setAttribute('aria-hidden', 'true');
        dotsWrap.appendChild(dot);
      });

      card.appendChild(dotsWrap);

      const dots = Array.from(dotsWrap.querySelectorAll('.en-mobile-image-dot'));

      function setActive(index) {
        dots.forEach(function (dot, dotIndex) {
          dot.classList.toggle('is-active', dotIndex === index);
        });

        requestAnimationFrame(function () {
          positionDots(card, images);
        });
      }

      function updateFromThemeActive() {
        let activeIndex = images.findIndex(function (img) {
          return img.classList.contains('is-active');
        });

        if (activeIndex < 0) activeIndex = 0;
        setActive(activeIndex);
      }

      images.forEach(function (img, index) {
        img.addEventListener('click', function () {
          setActive(index);
        });

        img.addEventListener('touchstart', function () {
          setActive(index);
        }, { passive: true });

        new MutationObserver(updateFromThemeActive).observe(img, {
          attributes: true,
          attributeFilter: ['class']
        });
      });

      requestAnimationFrame(function () {
        updateFromThemeActive();
        positionDots(card, images);
      });

      window.addEventListener('resize', function () {
        positionDots(card, images);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    buildMobileImageDots(document);

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) buildMobileImageDots(node);
        });
      });
    }).observe(document.body, {
      childList: true,
      subtree: true
    });
  });

  document.addEventListener('shopify:section:load', function (event) {
    buildMobileImageDots(event.target);
  });
})();

/* =========================================================
   COLLECTION SWATCHES — active underline sync after theme render
   ========================================================= */
(function () {
  if (window.__enSwatchActiveSyncInstalledV2) return;
  window.__enSwatchActiveSyncInstalledV2 = true;

  function activateLabel(label) {
    if (!label) return;

    var container = label.closest('.grid__swatch__container');
    if (!container) return;

    container.querySelectorAll('.swatch__button label').forEach(function (item) {
      item.classList.remove('is-active');
    });

    label.classList.add('is-active');
  }

  function activateDefault(container) {
    if (!container) return;

    var checkedInput = container.querySelector('input[type="radio"]:checked');
    var checkedLabel = checkedInput
      ? container.querySelector('label[for="' + checkedInput.id + '"]')
      : null;

    var firstLabel = checkedLabel || container.querySelector('.swatch__button label');

    if (firstLabel) activateLabel(firstLabel);
  }

  function activateAllDefaults() {
    document.querySelectorAll('.grid__swatch__container').forEach(function (container) {
      activateDefault(container);
    });
  }

  document.addEventListener('click', function (event) {
    var label = event.target.closest('.grid__swatch__container .swatch__button label');
    if (!label) return;

    activateLabel(label);
  }, true);

  document.addEventListener('change', function (event) {
    var input = event.target.closest('.grid__swatch__container input[type="radio"]');
    if (!input) return;

    var container = input.closest('.grid__swatch__container');
    var label = container ? container.querySelector('label[for="' + input.id + '"]') : null;

    if (label) activateLabel(label);
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    activateAllDefaults();

    setTimeout(activateAllDefaults, 150);
    setTimeout(activateAllDefaults, 500);
    setTimeout(activateAllDefaults, 1000);
  });

  document.addEventListener('shopify:section:load', function () {
    setTimeout(activateAllDefaults, 150);
  });

  new MutationObserver(function () {
    clearTimeout(window.__enSwatchActiveSyncTimer);
    window.__enSwatchActiveSyncTimer = setTimeout(activateAllDefaults, 100);
  }).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();

/* =========================================================
   COLLECTION SWATCHES — preload before swap, no white/black flash
   Keeps current image until new swatch image is ready
   ========================================================= */
(function () {
  if (window.__enSwatchPreloadBeforeSwapInstalled) return;
  window.__enSwatchPreloadBeforeSwapInstalled = true;

  var loadedImages = {};
  var syntheticClick = false;

  function preload(src) {
    return new Promise(function (resolve) {
      if (!src) return resolve();

      if (loadedImages[src]) return resolve();

      var img = new Image();

      img.onload = function () {
        loadedImages[src] = true;
        resolve();
      };

      img.onerror = function () {
        resolve();
      };

      img.src = src;
    });
  }

  function preloadAll(root) {
    (root || document)
      .querySelectorAll('.grid__swatch__container label[data-swatch-image]')
      .forEach(function (label) {
        var src = label.getAttribute('data-swatch-image');
        if (!src || loadedImages[src]) return;

        var img = new Image();
        img.onload = function () {
          loadedImages[src] = true;
        };
        img.src = src;
      });
  }

  function setActive(label) {
    var container = label.closest('.grid__swatch__container');
    if (!container) return;

    container.querySelectorAll('.swatch__button label').forEach(function (item) {
      item.classList.remove('is-active');
    });

    label.classList.add('is-active');
  }

  // Start preloading immediately
  preloadAll(document);

  document.addEventListener('DOMContentLoaded', function () {
    preloadAll(document);
    setTimeout(function () { preloadAll(document); }, 300);
    setTimeout(function () { preloadAll(document); }, 1000);
  });

  document.addEventListener('shopify:section:load', function (event) {
    preloadAll(event.target);
  });

  document.addEventListener('click', function (event) {
    var label = event.target.closest('.grid__swatch__container .swatch__button label[data-swatch-image]');
    if (!label) return;

    if (syntheticClick) return;

    var src = label.getAttribute('data-swatch-image');

    // If already loaded, let Pipeline run normally
    if (!src || loadedImages[src]) {
      setActive(label);
      return;
    }

    // Stop Pipeline for this click until image is ready
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();

    setActive(label);

    preload(src).then(function () {
      syntheticClick = true;
      label.click();
      syntheticClick = false;
    });
  }, true);

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) preloadAll(node);
      });
    });
  }).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();


/* =========================================================
   COLLECTION SWATCHES — hydrate empty Pipeline swatch forms
   Fixes swatches missing until refresh
   ========================================================= */
(function () {
  if (window.__enCollectionSwatchHydratorV1) return;
  window.__enCollectionSwatchHydratorV1 = true;

  var cache = {};
  var started = false;
  var scanTimer = null;
  var io = null;

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function clean(value) {
    return String(value == null ? '' : value).trim();
  }

  function fetchProduct(handle) {
    if (!handle) return Promise.resolve(null);

    if (!cache[handle]) {
      cache[handle] = fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (res) { return res.ok ? res.json() : null; })
        .catch(function () { return null; });
    }

    return cache[handle];
  }

  function getOptionIndex(product, optionName) {
    var wanted = clean(optionName || 'Color').toLowerCase();
    var options = product && product.options ? product.options : [];

    for (var i = 0; i < options.length; i++) {
      var option = options[i];
      var name = typeof option === 'string' ? option : option.name;
      if (clean(name).toLowerCase() === wanted) return i;
    }

    return 0;
  }

  function getVariantOption(variant, index) {
    if (!variant) return '';
    if (variant.options && variant.options[index] != null) return variant.options[index];
    return variant['option' + (index + 1)] || '';
  }

  function imageFor(product, variant) {
    if (variant && variant.featured_image) {
      if (typeof variant.featured_image === 'string') return variant.featured_image;
      if (variant.featured_image.src) return variant.featured_image.src;
    }

    if (variant && variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.src) {
      return variant.featured_media.preview_image.src;
    }

    if (product && product.featured_image) return product.featured_image;
    if (product && product.images && product.images.length) return product.images[0];

    return '';
  }

  function getCard(form) {
    return (
      form.closest('product-grid-item') ||
      form.closest('.product-grid-item') ||
      form.closest('.product-grid-item__container') ||
      form.closest('.grid__item')
    );
  }

  function setImgSrc(img, src) {
    if (!img || !src) return;

    img.removeAttribute('srcset');
    img.removeAttribute('data-srcset');
    img.removeAttribute('data-src');
    img.setAttribute('src', src);

    img.classList.remove('lazyload');
    img.classList.remove('lazyloading');
    img.classList.add('lazyloaded');
  }

  function swapCardImage(form, label) {
    var src = label.getAttribute('data-swatch-image');
    if (!src) return;

    var card = getCard(form);
    if (!card) return;

    var img =
      card.querySelector('[data-grid-image].is-active img') ||
      card.querySelector('.product-grid-item__image.is-active img') ||
      card.querySelector('[data-grid-image] img') ||
      card.querySelector('.product-grid-item__image img') ||
      card.querySelector('img');

    setImgSrc(img, src);

    var activeWrap = img ? (img.closest('[data-grid-image]') || img.closest('.product-grid-item__image')) : null;
    if (activeWrap) {
      activeWrap.style.backgroundImage = 'url("' + src + '")';

      toArray(card.querySelectorAll('[data-grid-image], .product-grid-item__image')).forEach(function (wrap) {
        wrap.classList.toggle('is-active', wrap === activeWrap || wrap.contains(img));
      });
    }

    var url = label.getAttribute('data-variant-url');
    if (url) {
      toArray(card.querySelectorAll('a[href*="/products/"]')).forEach(function (link) {
        link.setAttribute('href', url);
      });
    }
  }

  function setActive(form, label) {
    toArray(form.querySelectorAll('.swatch__button label')).forEach(function (item) {
      item.classList.remove('is-active');
    });

    label.classList.add('is-active');
  }

  function bindClicks(form) {
    if (form.__enSwatchHydratorClickBound) return;
    form.__enSwatchHydratorClickBound = true;

    form.addEventListener('click', function (event) {
      var label = event.target.closest && event.target.closest('label[data-en-hydrated-swatch="true"]');
      if (!label || !form.contains(label)) return;

      event.preventDefault();

      var input = label.htmlFor ? document.getElementById(label.htmlFor) : null;
      if (input) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      setActive(form, label);
      swapCardImage(form, label);
    });
  }

  function buildSwatches(form, product, handle) {
    if (!product || !product.variants || !product.variants.length) return false;

    var optionIndex = getOptionIndex(product, form.getAttribute('data-swatch-label') || 'Color');
    var byValue = {};
    var order = [];

    product.variants.forEach(function (variant) {
      var value = clean(getVariantOption(variant, optionIndex));
      if (!value || value === 'Default Title') return;

      if (!byValue[value]) {
        byValue[value] = variant;
        order.push(value);
      } else if (byValue[value].available === false && variant.available) {
        byValue[value] = variant;
      }
    });

    if (order.length <= 1) return false;

    var uid = String(product.id || handle || Date.now()) + '-' + Math.random().toString(36).slice(2, 8);
    form.innerHTML = '';

    order.forEach(function (value, index) {
      var variant = byValue[value];
      var image = imageFor(product, variant);
      var inputId = 'en-grid-swatch-' + uid + '-' + index;

      var wrap = document.createElement('radio-swatch');
      wrap.className = 'swatch__button';

      var input = document.createElement('input');
      input.type = 'radio';
      input.name = 'en-grid-color-' + uid;
      input.id = inputId;
      input.value = value;
      input.setAttribute('aria-label', value);
      if (index === 0) input.checked = true;

      var label = document.createElement('label');
      label.htmlFor = inputId;
      label.title = value;
      label.setAttribute('data-swatch', value);
      label.setAttribute('data-en-hydrated-swatch', 'true');
      label.setAttribute('data-variant-id', variant.id);
      label.setAttribute('data-variant-url', '/products/' + handle + '?variant=' + variant.id);

      if (image) {
        label.setAttribute('data-swatch-image', image);
        label.setAttribute('data-fetched-image', 'url("' + image + '")');
        label.style.setProperty('--swatch-image', 'url("' + image + '")');
      }

      if (index === 0) label.classList.add('is-active');

      wrap.appendChild(input);
      wrap.appendChild(label);
      form.appendChild(wrap);
    });

    bindClicks(form);

    if (typeof enApplyGridSwatchImages === 'function') {
      enApplyGridSwatchImages(form);
    }

    return true;
  }

  function hydrateForm(form) {
    if (!form || form.dataset.enSwatchHydratorReady === 'true') return;

    if (form.querySelector('.swatch__button label')) {
      bindClicks(form);
      form.dataset.enSwatchHydratorReady = 'true';
      return;
    }

    if (form.dataset.enSwatchHydrating === 'true') return;

    var handle = form.getAttribute('data-swatch-handle');
    if (!handle) return;

    form.dataset.enSwatchHydrating = 'true';

    fetchProduct(handle).then(function (product) {
      form.dataset.enSwatchHydrating = 'false';

      if (!form.isConnected) return;
      if (form.querySelector('.swatch__button label')) {
        bindClicks(form);
        form.dataset.enSwatchHydratorReady = 'true';
        return;
      }

      buildSwatches(form, product, handle);
      form.dataset.enSwatchHydratorReady = 'true';
    });
  }

  function watchForm(form) {
    if (!form || form.dataset.enSwatchHydratorObserved === 'true') return;

    form.dataset.enSwatchHydratorObserved = 'true';

    if (form.querySelector('.swatch__button label')) {
      bindClicks(form);
      return;
    }

    if (io) io.observe(form);
    else hydrateForm(form);
  }

  function scan(root) {
    toArray((root || document).querySelectorAll('form[data-grid-swatches][data-swatch-handle]')).forEach(watchForm);
  }

  function scheduleScan(root) {
    clearTimeout(scanTimer);
    scanTimer = setTimeout(function () {
      scan(root || document);
    }, 80);
  }

  function start() {
    if (started) return;
    started = true;

    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          io.unobserve(entry.target);
          hydrateForm(entry.target);
        });
      }, { rootMargin: '1400px 0px' });
    }

    scan(document);
    setTimeout(function () { scan(document); }, 250);
    setTimeout(function () { scan(document); }, 900);
    setTimeout(function () { scan(document); }, 1800);

    if (document.body) {
      new MutationObserver(function (mutations) {
        var shouldScan = false;

        mutations.forEach(function (mutation) {
          if (mutation.addedNodes && mutation.addedNodes.length) shouldScan = true;
        });

        if (shouldScan) scheduleScan(document);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  window.addEventListener('load', function () {
    scan(document);
    setTimeout(function () { scan(document); }, 1000);
  });

  document.addEventListener('shopify:section:load', function (event) {
    scheduleScan(event.target);
  });
})();

/* =========================================================
   COLLECTION SWATCHES — force image switch on first-load swatches
   ========================================================= */
(function () {
  if (window.__enGridSwatchImageSwitchBridgeV2) return;
  window.__enGridSwatchImageSwitchBridgeV2 = true;

  function getCard(el) {
    return (
      el.closest('product-grid-item') ||
      el.closest('.product-grid-item') ||
      el.closest('.product-grid-item__container') ||
      el.closest('.grid__item')
    );
  }

  function normalizeUrl(src) {
    if (!src) return '';
    src = String(src).trim();

    if (src.indexOf('//') === 0) return window.location.protocol + src;
    if (src.indexOf('/') === 0) return window.location.origin + src;

    return src;
  }

  function preload(src) {
    return new Promise(function (resolve) {
      if (!src) return resolve('');

      var img = new Image();

      img.onload = function () {
        resolve(src);
      };

      img.onerror = function () {
        resolve(src);
      };

      img.src = src;
    });
  }

  function getMainImage(card) {
    return (
      card.querySelector('.product-grid-item__link [data-grid-image].is-active img') ||
      card.querySelector('.product-grid-item__link .is-active img') ||
      card.querySelector('.product-grid-item__link img') ||
      card.querySelector('a[href*="/products/"] [data-grid-image].is-active img') ||
      card.querySelector('a[href*="/products/"] .is-active img') ||
      card.querySelector('a[href*="/products/"] img') ||
      card.querySelector('[data-grid-image].is-active img') ||
      card.querySelector('[data-grid-image] img') ||
      card.querySelector('img')
    );
  }

  function setImage(img, src) {
    if (!img || !src) return;

    var picture = img.closest('picture');
    if (picture) {
      picture.querySelectorAll('source').forEach(function (source) {
        source.removeAttribute('srcset');
        source.removeAttribute('data-srcset');
        source.setAttribute('srcset', src);
      });
    }

    img.removeAttribute('srcset');
    img.removeAttribute('data-srcset');
    img.removeAttribute('data-src');
    img.removeAttribute('data-widths');
    img.removeAttribute('data-sizes');

    img.setAttribute('src', src);

    img.classList.remove('lazyload');
    img.classList.remove('lazyloading');
    img.classList.add('lazyloaded');

    var wrap = img.closest('[data-grid-image], .product__grid__image, .product-grid-item__image, .lazy-image');

    if (wrap) {
      wrap.style.backgroundImage = 'url("' + src + '")';
      wrap.style.backgroundSize = 'cover';
      wrap.style.backgroundPosition = 'center';
    }
  }

  function setActive(label) {
    var container = label.closest('.grid__swatch__container');
    if (!container) return;

    container.querySelectorAll('.swatch__button label').forEach(function (item) {
      item.classList.remove('is-active');
    });

    label.classList.add('is-active');

    var input = label.htmlFor ? document.getElementById(label.htmlFor) : null;
    if (input && !input.checked) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function updateLinks(card, label) {
    var url = label.getAttribute('data-variant-url');
    if (!url) return;

    card.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
      link.setAttribute('href', url);
    });
  }

  function switchImage(label) {
    var src = normalizeUrl(label.getAttribute('data-swatch-image'));
    if (!src) return;

    var card = getCard(label);
    if (!card) return;

    setActive(label);
    updateLinks(card, label);

    var token = String(Date.now()) + Math.random();
    card.dataset.enSwatchImageToken = token;

    preload(src).then(function (readySrc) {
      if (!readySrc) return;
      if (card.dataset.enSwatchImageToken !== token) return;

      var img = getMainImage(card);
      setImage(img, readySrc);
    });
  }

  function onSwatchIntent(event) {
    var label = event.target.closest &&
      event.target.closest('.grid__swatch__container .swatch__button label[data-swatch-image]');

    if (!label) return;

    switchImage(label);
  }

  document.addEventListener('pointerdown', onSwatchIntent, true);
  document.addEventListener('click', onSwatchIntent, true);
  document.addEventListener('touchstart', onSwatchIntent, { capture: true, passive: true });
})();

/* =========================================================
   Product page ATC -> redirect to Cart after successful add
   ========================================================= */
(function () {
  if (window.__ENANTIO_PRODUCT_ATC_REDIRECT_TO_CART__) return;
return; // Disable the custom redirect and allow the theme's cart drawer.

  var shouldRedirectAfterATC = false;
  var redirectTimer = null;

  function isProductPage() {
    return document.body && document.body.classList.contains('template-product');
  }

  function isMainProductATC(target) {
    if (!isProductPage()) return false;
    if (!target || !target.closest) return false;

    var button = target.closest(
      'button[name="add"], button[data-add-to-cart], .btn--add-to-cart, [data-add-to-cart]'
    );

    if (!button) return false;

    // Do not redirect from upsell modal/buttons unless you want that too
    if (button.closest('[data-upsell-holder], [data-upsell-modal], upsell-product')) return false;

    var form = button.closest('form[action*="/cart/add"], [data-product-form]');
    if (!form) return false;

    return !!form.closest('[data-section-type="product"], .product-section, .product-page');
  }

  function armRedirect() {
    shouldRedirectAfterATC = true;

    clearTimeout(redirectTimer);
    redirectTimer = setTimeout(function () {
      shouldRedirectAfterATC = false;
    }, 12000);
  }

  // Do not block the click. Just mark that this ATC should redirect after success.
  document.addEventListener('click', function (event) {
    if (isMainProductATC(event.target)) {
      armRedirect();
    }
  }, true);

  // Backup for form submit / keyboard submit
  document.addEventListener('submit', function (event) {
    if (!isProductPage()) return;

    var form = event.target && event.target.closest
      ? event.target.closest('form[action*="/cart/add"]')
      : null;

    if (!form) return;
    if (form.closest('[data-upsell-holder], [data-upsell-modal], upsell-product')) return;
    if (!form.closest('[data-section-type="product"], .product-section, .product-page')) return;

    armRedirect();
  }, true);

  // Pipeline fires this only after the AJAX add succeeds.
  // Capture it before the theme opens the popdown/cart drawer.
  document.addEventListener('theme:cart:popdown', function (event) {
    if (!isProductPage()) return;
    if (!shouldRedirectAfterATC) return;

    shouldRedirectAfterATC = false;
    clearTimeout(redirectTimer);

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();

    window.location.href =
      (window.theme && window.theme.routes && window.theme.routes.cart)
        ? window.theme.routes.cart
        : '/cart';
  }, true);
})();

/* =========================================================
   COLLECTION SWATCH COLORS — fix gray colors before refresh
   ========================================================= */
(function () {
  if (window.__enCollectionSwatchColorFixV1) return;
  window.__enCollectionSwatchColorFixV1 = true;

  var colorMap = {
    black: '#000000',
    white: '#ffffff',
    offwhite: '#f8f5e9',
    ivory: '#fffff0',
    cream: '#fffdd0',
    beige: '#f5f5dc',
    khaki: '#f0e68c',
    tan: '#d2b48c',
    camel: '#c19a6b',
    sand: '#c2b280',
    brown: '#8b4513',
    darkbrown: '#654321',
    espresso: '#3c2218',
    grey: '#808080',
    gray: '#808080',
    lightgrey: '#d3d3d3',
    lightgray: '#d3d3d3',
    darkgrey: '#555555',
    darkgray: '#555555',
    charcoal: '#36454f',
    silver: '#c0c0c0',
    blue: '#0000ff',
    darkblue: '#00008b',
    skyblue: '#87ceeb',
    lightblue: '#add8e6',
    navy: '#000080',
    navyblue: '#000080',
    teal: '#008080',
    turquoise: '#40e0d0',
    green: '#008000',
    darkgreen: '#006400',
    olive: '#808000',
    emerald: '#046307',
    red: '#ff0000',
    darkred: '#8b0000',
    burgundy: '#800020',
    maroon: '#800000',
    oxblood: '#4a0000',
    pink: '#ffc0cb',
    lightpink: '#ffb6c1',
    purple: '#800080',
    violet: '#8f00ff',
    orange: '#ffa500',
    yellow: '#ffff00',
    gold: '#d4af37'
  };

  function normalizeColorName(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9]/g, '');
  }

  function getSwatchColor(label) {
    var key = normalizeColorName(label.getAttribute('data-swatch'));

    if (colorMap[key]) {
      return colorMap[key];
    }

    if (key && window.CSS && CSS.supports('color', key)) {
      return key;
    }

    return '';
  }

  function needsColor(label) {
    var current = label.style
      .getPropertyValue('--swatch')
      .trim()
      .toLowerCase()
      .replace(/\s/g, '');

    return (
      current === '' ||
      current === '#e5e5e5' ||
      current === 'rgb(229,229,229)' ||
      current === 'rgba(229,229,229,1)'
    );
  }

  function applyColor(label) {
    if (!label || !label.matches('label[data-swatch]')) return;
    if (!needsColor(label)) return;

    var color = getSwatchColor(label);
    if (!color) return;

    label.style.setProperty('--swatch', color);
  }

  function applyAll(root) {
    var scope = root || document;

    if (scope.nodeType === 1 && scope.matches('label[data-swatch]')) {
      applyColor(scope);
    }

    if (scope.querySelectorAll) {
      scope.querySelectorAll(
        'form[data-grid-swatches] label[data-swatch]'
      ).forEach(applyColor);
    }
  }

  applyAll(document);

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'attributes') {
        applyColor(mutation.target);
        return;
      }

      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          applyAll(node);
        }
      });
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'data-swatch']
  });

  document.addEventListener('DOMContentLoaded', function () {
    applyAll(document);
  });

  window.addEventListener('load', function () {
    applyAll(document);
  });

  window.addEventListener('pageshow', function () {
    applyAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    applyAll(event.target);
  });
})();

/* Open the cart drawer after a successful product-page add */
(function () {
  if (window.__enantioOpenDrawerAfterAdd) return;
  window.__enantioOpenDrawerAfterAdd = true;

  document.addEventListener('theme:cart:popdown', async function (event) {
    if (!document.body.classList.contains('template-product')) return;

    var drawer = document.querySelector('[data-drawer="drawer-cart"]');
    if (!drawer) return;

    // Replace the added-to-cart notification with the drawer.
    event.preventDefault();
    event.stopImmediatePropagation();

    var cartUrl = window.theme.routes.cart;

    try {
      var response = await fetch(cartUrl + '.js', {
        credentials: 'same-origin',
        cache: 'no-store'
      });

      if (!response.ok) throw new Error('Could not refresh cart');

      var cart = await response.json();

      // Update the cart data before the drawer renders its contents.
      document.dispatchEvent(new CustomEvent('theme:cart:change', {
        detail: { cart: cart },
        bubbles: true
      }));
    } catch (error) {
      console.error('[ENANTIODROMIA] Cart refresh failed:', error);
    }

    drawer.dispatchEvent(new CustomEvent('theme:drawer:open', {
      bubbles: false
    }));
  }, true);
})();

/* Lock sideways gallery swipes while allowing vertical scrolling */
(() => {
  function setupGallerySwipes() {
    document.querySelectorAll(
      '[data-product-slideshow] .flickity-viewport'
    ).forEach((gallery) => {
      if (gallery.dataset.swipeDirectionReady) return;
      gallery.dataset.swipeDirectionReady = 'true';

      let startX = 0;
      let startY = 0;
      let direction = null;
      let active = false;

      gallery.addEventListener('touchstart', (event) => {
        active = window.matchMedia('(max-width: 767px)').matches
          && event.touches.length === 1;

        direction = null;

        if (!active) return;

        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
      }, { passive: true });

      function handleGalleryMove(event) {
        if (
          event.type === 'pointermove'
          && event.pointerType !== 'touch'
        ) {
          return;
        }

        if (event.touches && event.touches.length !== 1) {
          active = false;
          return;
        }

        if (!active) return;

        const point = event.touches ? event.touches[0] : event;
        const dx = Math.abs(point.clientX - startX);
        const dy = Math.abs(point.clientY - startY);

        if (!direction) {
          if (Math.max(dx, dy) < 2) return;
          direction = dx > dy ? 'horizontal' : 'vertical';
        }

        if (direction === 'vertical') {
          // Let the page scroll without dragging the carousel.
          event.stopPropagation();
        } else if (
          event.type === 'touchmove'
          && event.cancelable
        ) {
          // Let the carousel slide without scrolling the page.
          event.preventDefault();
        }
      }

      gallery.addEventListener('touchmove', handleGalleryMove, {
        passive: false,
        capture: true
      });

      gallery.addEventListener('pointermove', handleGalleryMove, {
        passive: true,
        capture: true
      });

      function reset() {
        active = false;
        direction = null;
      }

      gallery.addEventListener('touchend', reset, {
        passive: true
      });

      gallery.addEventListener('touchcancel', reset, {
        passive: true
      });
    });
  }

  if (document.readyState === 'complete') {
    setupGallerySwipes();
  } else {
    window.addEventListener('load', setupGallerySwipes, {
      once: true
    });
  }

  document.addEventListener(
    'shopify:section:load',
    setupGallerySwipes
  );
})();